import { Component, Input, OnInit } from '@angular/core';
import { AnalyticsService } from '../../../../services/analytics.service';
import { TutorService } from '../../../../services/tutor.service';

@Component({
  selector: 'app-tutor-filter-control',
  templateUrl: './tutor-filter-control.component.html',
  styleUrl: './tutor-filter-control.component.scss',
})
export class TutorFilterControlComponent implements OnInit {
  @Input() analyticsPage:
    | 'sessions'
    | 'events'
    | 'semantics'
    | 'live' = 'sessions';

  selectedTutorId: string | null = null;
  readonly allTutorsValue = '__all_tutors__';

  constructor(
    public analyticsService: AnalyticsService,
    public tutorService: TutorService
  ) {
    this.selectedTutorId = this.analyticsService.tutorId;
  }

  ngOnInit(): void {
    if (!this.tutorService.tutors$.value.length) {
      this.tutorService.listTutors().subscribe();
    }
  }

  onTutorSelect(value: string) {
    const tutorId = value === this.allTutorsValue ? null : value;

    if (this.selectedTutorId === tutorId) {
      return;
    }

    this.selectedTutorId = tutorId;
    this.analyticsService.tutorId = tutorId;

    this.refreshData();
  }

  private refreshData() {
    switch (this.analyticsPage) {
      case 'sessions':
        this.analyticsService.fetchSessionsData();
        break;
      case 'events':
        this.analyticsService.fetchEventsData();
        break;
      case 'semantics':
        this.analyticsService.fetchSemanticsData();
        break;
      case 'live':
        this.analyticsService.fetchLiveData();
        break;
    }
  }
}
